import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { TogetherDIPStageContainer } from 'app/models/app.models';
import { DipStateService } from 'app/services/dip-state-service.service';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { SubmissionRequestStatus } from 'app/models/enums';

@Component({
    selector: 'application-overview',
    templateUrl: './application-overview.component.html',
    styleUrls: ['./application-overview.component.scss'],
    standalone: false
})
export class ApplicationOverviewComponent implements OnInit {
    /**
     * The current stage
     * 
     * @type {TogetherDIPStageContainer}
     * @memberof ApplicationOverviewComponent
     */
    @Input() stage: TogetherDIPStageContainer;
    /**
     * Notify that stage is changing
     * 
     * @type {EventEmitter<string>}
     * @memberof ApplicationOverviewComponent
     */
    @Output() stageChanging: EventEmitter<string> = new EventEmitter<string>();
    /**
     * The id of the case geing processed
     * 
     * @type {string}
     * @memberof ApplicationOverviewComponent
     */
    @Input() caseId: string;
    /**
     * Get loading status from state
     * 
     * @readonly
     * @type {boolean}
     * @memberof ApplicationOverviewComponent
     */
    get IsLoading(): boolean {
        return this.state.IsLoading;
    }

    applicationSubmitForm: UntypedFormGroup;
    applicationConfirm1: UntypedFormControl = new UntypedFormControl(null, [
        Validators.requiredTrue,
    ]);
    applicationConfirm2: UntypedFormControl = new UntypedFormControl(null, [
        Validators.requiredTrue,
    ]);
    applicationConfirm3: UntypedFormControl = new UntypedFormControl(null, [
        Validators.requiredTrue,
    ]);

    get canProceed() {
        return this.applicationSubmitForm.valid;
    }

    constructor(private state: DipStateService, private fb: UntypedFormBuilder) { }

    ngOnInit() {
        this.createForm();
    }
    /**
      * Handles moving forward.
      *
      * @param {any} forward
      * @memberof ApplicationOverviewComponent
      */
    goForward(forward) {
        if (!this.canProceed) {
            return false;
        }
        // FLag that it is OK to submit the DIP.
        this.state.applicationSubmissionStatus = SubmissionRequestStatus.Initialised;
        this.stageChanging.emit(this.stage.forward_stage.reference);
    }

    /**
     * Handles move backward.
     *
     * @param {any} backward
     * @memberof ApplicationOverviewComponent
     */
    goBackward(backward) {
        this.stageChanging.emit(this.stage.backward_stage.reference);
    }
    gotoStage(stage) {
        this.stageChanging.emit(stage);
    }


    createForm() {
        this.applicationSubmitForm = this.fb.group({
            applicationConfirm1: this.applicationConfirm1,
            applicationConfirm2: this.applicationConfirm2,
            applicationConfirm3: this.applicationConfirm3,
        });
    }

}
